import { Link } from 'react-router-dom';
import { blogs } from '../data/blogData';
import NavbarComponent from '../components/navbar';
import FooterComponent from '../components/footer';
import Card from 'react-bootstrap/Card';

const BlogList = () => {
    let reversedBlogList = blogs.slice(0).reverse();
    return(
        <>
            <NavbarComponent />
            <div className='blog-list-wrapper'>
                <div className='blog-list'>
                    {reversedBlogList.map((blog) => (
                        <Link to={blog.id} style={{ textDecoration: 'none' }}>
                            <Card key={blog.id} className='mb-4'>
                                <Card.Body>
                                    <Card.Title>{blog.title}</Card.Title>
                                    <Card.Subtitle className='mb-2 fw-normal'>{blog.date}</Card.Subtitle>
                                    <Card.Text>{blog.preview}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    ))}
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

export default BlogList;